import { IonInput, IonLabel, IonText } from '@ionic/react';
import {
  ControlProps,
  ControlState,
  computeLabel,
  isIntegerControl,
  isNumberControl,
  or,
  rankWith,
} from '@jsonforms/core';
import { Control, withJsonFormsControlProps } from '@jsonforms/react';
import { merge } from 'lodash';
import { IonItem } from '../../ionic/IonItem';

class IonicNumberInputControlInner extends Control<ControlProps, ControlState> {
  private hasFocused = false;
  render() {
    const {
      description,
      enabled,
      errors,
      label,
      uischema,
      visible,
      required,
      config,
      handleChange,
      path,
      data,
      schema,
    } = this.props;

    const appliedUiSchemaOptions = merge({}, config, uischema.options);

    const errorText = this.hasFocused ? (
      <IonText color="danger">{errors}</IonText>
    ) : null;

    const classList: string[] = ['item-container'];
    if (visible === false) {
      classList.push('ion-hide');
    }

    const computedLabel = computeLabel(
      typeof label === 'string' ? label : '',
      required ?? false,
      appliedUiSchemaOptions.hideRequiredAsterisk
    );

    return (
      <IonItem lines={'full'} className={classList.join(' ')}>
        <IonInput
          aria-label={computedLabel}
          labelPlacement="floating"
          placeholder={description}
          value={data ?? schema.default}
          disabled={!enabled}
          inputmode={schema.type === 'integer' ? 'numeric' : 'decimal'}
          onKeyPress={(e) => {
            const isNumber = /[-0-9]/;
            const isDecimalPoint = /\./;
            if (
              !isNumber.test(e.key) &&
              !(schema.type === 'number' && isDecimalPoint.test(e.key))
            ) {
              e.preventDefault();
            }
          }}
          onIonInput={(e) => {
            const value = e.detail.value;
            if (
              value !== undefined &&
              value !== null &&
              String(data) !== value
            ) {
              handleChange(path, Number(value));
            }
          }}
          onIonFocus={() => {
            this.hasFocused = true;
            this.onFocus();
          }}
          onIonBlur={() => {
            this.onBlur();
          }}
        >
          <div slot="label">
            <IonLabel color="primary">
              {computedLabel} {errorText}
            </IonLabel>
          </div>
        </IonInput>
      </IonItem>
    );
  }
}

const IonicNumberInputTester = rankWith(
  1,
  or(isNumberControl, isIntegerControl)
);

const IonicNumberInputControl = withJsonFormsControlProps(
  IonicNumberInputControlInner
);
export { IonicNumberInputControl, IonicNumberInputTester };
